import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linebreak',
    standalone: true,
})

export class LinebreakPipe implements PipeTransform {

  transform(text: string): string {
    return text.replace(/\r\n/g, '<br>');
  }

}